import catClass from './catClass'
import categoryName from './categoryName'
import classification from './classification'
import getActions from './actions'

export default function getColumns<T>( canEdit: boolean, openEditModal: ( productClass: T ) => void ) {
	return [
		catClass,
		categoryName,
		classification,
		getActions( canEdit, openEditModal ),
	]
}
